export enum PASSWORD_STATUS {
  ERROR = 'error',
  DEFAULT = 'default',
}

export enum PASSWORD_POLICY_ITEM_STATUS {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  IN_PROGRESS = 'in_progress',
  MATCH = 'match',
  MISMATCH = 'mismatch',
}

/** Mirrors the backend `SignupFailureReason`; only the cases the form presents differently appear here. */
export enum SignupFailureReason {
  TOO_MANY_ATTEMPTS_FROM_DEVICE = 'too_many_attempts_from_device',
}
